// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: 'AIzaSyDec9AYQWbJQjV-3u8xOXdV3KMXjkEmDi8',
    authDomain: "akaash-4385d.firebaseapp.com",
    projectId: "akaash-4385d",
    storageBucket: "akaash-4385d.appspot.com",
    messagingSenderId: "476509915243",
    appId: "1:476509915243:web:38eb90e1cea75b4ed8c92e",
    measurementId: "G-JJ94M6J4R1",
    vapidKey:
      'BNqWqdw8c5Q6zOHvORiyXWhNprbfPagF5TH572p0kqpkbe3tche6kRZ6NL87LthGzXxTspdZCO1yogmc_0Yh2CI'
  },
  path: '/firebase-messaging-sw.js',
  scope: '/',
  base_url: 'https://api-dev.mega-store.app/factory/api/v1',
  imageUrl: 'https://api-dev.mega-store.app/common/api/v1/',
  storageKey: 'megaStoreFactoryAccessToken',
  rememberMeKey: 'isRememberMeMegaFactory',
  factoryIdKey: 'factoryIdMegaFactory',
  socketUrl: 'https://operational-api-dev.mega-store.app',
  adminOtpId: '_thserTz_12',
  googleKey: 'AIzaSyALPDZ5um7flrifa-h33WXQhBxKPdpVpIc',
  operational_url:
    'https://api-dev.mega-store.app/operational/api/v1/operational/',
  // firebaseConfig: {
  //   apiKey: 'AIzaSyCpkkelv5zsbCOtzAkYaAz3OQerFkGD0Gk',
  //   authDomain: 'apptunix-food-customer.firebaseapp.com',
  //   projectId: 'apptunix-food-customer',
  //   storageBucket: 'apptunix-food-customer.appspot.com',
  //   messagingSenderId: '92607762064',
  //   appId: '1:92607762064:web:aa734c068e3fb3d7299215',
  //   vapidKey:
  //     'BB-EKssjMxF7dmu7jtWxw1T_lI-BcmwgseXqh71a3wsLsvsrnIoBIzcmitpmkuUgzSoYbyqt5hApqiXO8xynFzk'
  // },
  // // path: '/firebase-messaging-sw.js',
  // // scope: '/'
  // path: '/megastore/factory/firebase-messaging-sw.js',
  // scope: '/megastore/factory/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
